// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"5b53aa6d","139":"aa8d2ca7","197":"43c5e585","380":"d1e2f667","453":"9465ae8b","521":"4509fdc0","708":"426f4d6c","742":"8ea381c5","858":"9a3ea4e7","944":"0973fa8f"}[chunkId] + ".chunk.js";
};